import { BoardType } from "./board-type";
import { BoardVisitor } from "./board-visitor";
export function getBoardType(board) {
    return BoardTypeConverter.getInstance().visit(board);
}
class BoardTypeConverter extends BoardVisitor {
    visitVolleyballBoard() {
        return BoardType.Volleyball;
    }
    visitVolleyballHalfBoard() {
        return BoardType.VolleyballHalf;
    }
    visitBasketballBoard() {
        return BoardType.Basketball;
    }
    visitBasketballHalfBoard() {
        return BoardType.BasketballHalf;
    }
    visitSoccerBoard() {
        return BoardType.Soccer;
    }
    visitSoccerHalfBoard() {
        return BoardType.SoccerHalf;
    }
    visitIceHockeyBoard() {
        return BoardType.IceHockey;
    }
    visitIceHockeyHalfBoard() {
        return BoardType.IceHockeyHalf;
    }
    visitRugbyBoard() {
        return BoardType.Rugby;
    }
    visitRugbyHalfBoard() {
        return BoardType.RugbyHalf;
    }
    visitBaseballBoard() {
        return BoardType.Baseball;
    }
    visitCricketBoard() {
        return BoardType.Cricket;
    }
    static getInstance() {
        return this.instance;
    }
}
BoardTypeConverter.instance = new BoardTypeConverter();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWJvYXJkLXR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc3BvcnRzL2JvYXJkLXR5cGUvZ2V0LWJvYXJkLXR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUN6QyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFL0MsTUFBTSxVQUFVLFlBQVksQ0FBQyxLQUFZO0lBQ3ZDLE9BQU8sa0JBQWtCLENBQUMsV0FBVyxFQUFFLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ3ZELENBQUM7QUFFRCxNQUFNLGtCQUFtQixTQUFRLFlBQXVCO0lBRzVDLG9CQUFvQjtRQUM1QixPQUFPLFNBQVMsQ0FBQyxVQUFVLENBQUM7SUFDOUIsQ0FBQztJQUVTLHdCQUF3QjtRQUNoQyxPQUFPLFNBQVMsQ0FBQyxjQUFjLENBQUM7SUFDbEMsQ0FBQztJQUVTLG9CQUFvQjtRQUM1QixPQUFPLFNBQVMsQ0FBQyxVQUFVLENBQUM7SUFDOUIsQ0FBQztJQUVTLHdCQUF3QjtRQUNoQyxPQUFPLFNBQVMsQ0FBQyxjQUFjLENBQUM7SUFDbEMsQ0FBQztJQUVTLGdCQUFnQjtRQUN4QixPQUFPLFNBQVMsQ0FBQyxNQUFNLENBQUM7SUFDMUIsQ0FBQztJQUVTLG9CQUFvQjtRQUM1QixPQUFPLFNBQVMsQ0FBQyxVQUFVLENBQUM7SUFDOUIsQ0FBQztJQUVTLG1CQUFtQjtRQUMzQixPQUFPLFNBQVMsQ0FBQyxTQUFTLENBQUM7SUFDN0IsQ0FBQztJQUVTLHVCQUF1QjtRQUMvQixPQUFPLFNBQVMsQ0FBQyxhQUFhLENBQUM7SUFDakMsQ0FBQztJQUVTLGVBQWU7UUFDdkIsT0FBTyxTQUFTLENBQUMsS0FBSyxDQUFDO0lBQ3pCLENBQUM7SUFFUyxtQkFBbUI7UUFDM0IsT0FBTyxTQUFTLENBQUMsU0FBUyxDQUFDO0lBQzdCLENBQUM7SUFFUyxrQkFBa0I7UUFDMUIsT0FBTyxTQUFTLENBQUMsUUFBUSxDQUFDO0lBQzVCLENBQUM7SUFFUyxpQkFBaUI7UUFDekIsT0FBTyxTQUFTLENBQUMsT0FBTyxDQUFDO0lBQzNCLENBQUM7SUFFRCxNQUFNLENBQUMsV0FBVztRQUNoQixPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7SUFDdkIsQ0FBQzs7QUFwRHVCLDJCQUFRLEdBQUcsSUFBSSxrQkFBa0IsRUFBRSxDQUFDIn0=